import React from 'react';
import Image from '../Image/image-component'; // Adjust path
import VideoComponent from '../Video/video-component'; // Adjust path
import { isVideoUrl } from '../../Services/ApiService';

export default function MediaComponent({
    src,
    image,
    video,
    media,
    alt = 'Media content',
    className = '',
    wrapperClassName = '',
    width,
    quality = 70,
    useSekeleton = true,
    autoPlayWidth = 0,
    objectFit = 'cover',
    eager = false,
}) {

    const finalSrc = video || image || media || src;
    if (!finalSrc) return null;
    const isActuallyVideo = !!video || isVideoUrl(finalSrc);

    if (isActuallyVideo) {
        return (
            <VideoComponent
                video={finalSrc}
                autoPlayWidth={autoPlayWidth}
                className={className}
                wrapperClassName={wrapperClassName}
                useSekeleton={useSekeleton}
            />
        );
    }

    return (
        <Image
            src={finalSrc}
            alt={alt}
            width={width}
            quality={quality}
            className={className}
            wrapperClassName={wrapperClassName}
            useSekeleton={useSekeleton}
            objectFit={objectFit}
            eager={eager}
        />
    );
}